import ConnectOneBank from './ConnectOneBank.png';
import NavyFederal from './NavyFCU.png';
import AdvantageFCU from './AdvantageFCU.png';
import GPOFCU from './GPOFCU.png';
import GeCreditUnion from './GECreditUnion.png';
import SyracuseFireDepartment from './SyracuseFireDepartmentFCU.png';
import SolvayBank from './SolvayBank.png';
import FirstHeritage from './FirstHeritageFCU.png';
import WatertownSavingsBank from './WatertownSavingsBank.png';
import CanandalguaFCU from './CanandalguaFCU.png';
import GSL from './GSL.png';
import SummitFCU from './SummitFCU.png';
import PittsfordFCU from './PittsfordFCU.png';
import ReliantCreditUnion from './ReliantCreditUnion.png';
import OntarioShoresFCU from './OntarioShoresFCU.png';
import GreatErieFCU from './GreatErieFCU.png';
import MeridaCCU from './MeridaCCU.png';
import Affinity from './Affinity.png';
import PicatinnyFCU from './PicatinnyFCU.png';
import PolishAndSlavic from './Polish&Slavic.png';
import Citibank from './Citi.png';

import BerkshireBank from './BerkshireBank.png';
import Kinecta from './Kinecta.png';
import TogetherCreditUnion from './TogetherCreditUnion.png';
import BroadviewFCU from './BroadviewFCU.png';
import NextStepFCU from './NextStepFCU.png';
import EightOhTwoCreditUnion from './802CreditUnion.png';
import GreenMountainCU from './GreenMountainCU.png';
import MAndTBank from './M&TBank.png';
import EastRiseCU from './EastRiseCU.png';
import NorthCountryCreditUnion from './NorthCountryCreditUnion.png';
import OneCreditUnion from './OneCreditUnion.png';
import OpportunitiesCreditUnion from './OpportunitiesCreditUnion.png';
import VermontFCU from './VermontFCU.png';
import AccessFCU from './AccessFCU.png';
import OswegoTeachersEmployeesFCU from './OswegoTeachersEmployeesFCU.png';
import Ameri from './Ameri.png';
import NorthernCreditUnion from './NorthernCreditUnion.png';
import CobblestoneCountryFCU from './CobblestoneCountryFCU.png';
import Alliant from './Alliant.png';
import BokFinancial from './BokFinancial.png';
import Huntington from './Huntington.png';
import PenFCU from './PenFCU.png';
import UsBank from './USBank.png';
import NBKCBank from './NBKCBank.png';

// New Logos Added
import XCEL_FCU from './XCEL_FCU.jpg';
import WINGS_FCU from './Wings_FCU.jpg';

import WEOKIE_FEDERAL_CREDIT_UNION from './WEOKIE_FCU.jpg';

import VANTAGE_WEST_CREDIT_UNION from './Vantage_West_CU.png';

import VAN_LYONS_EMPLOYEES_FCU from './Van_Lyons_Employees_FCU.png';

import VALLEY_STRONG_CREDIT_UNION from './Valley_Strong_CU.png';
import VALLEY_FEDERAL_CREDIT_UNION from './Valley_FCU.png';
import VALLEY_CCU from './Valley_CCU.png';
import UTAH_FIRST_FEDERAL_CREDIT from './Utah_First_FCU.png';
import UPSTATE_TELCO_FEDERAL_CREDIT from './Upstate_Telco_FCU.png';
import UK_FCU from './University_of_Kentucky_FCU.png';
import Union_Fidelity_Federal_Credit from './Union_Fidelity_FCU.png';
import TYNDALL_CREDIT_UNION from './Tyndall_Credit_Union.jpg';
import TTCU_FEDERAL_CREDIT_UNION from './TTCu_FCU.jpg';
import TruMark_Federal_Credit_Union from './TruMark_FCU.jpg';
import Town_And_Country_Federal_Credit_Union from './Town_And_Country_FCU.jpg';
import GOLDEN_ONE_Credit_Union from './Golden_One_CU.png';
import Texhillco_SCHOOL_EMPLOYEES_FEDERAL_CREDIT_UNION from './Texhillco_School_Employees_FCU.png';
import Tennessee_Valley_Federal_Credit_Union from './Tennessee_Valley_FCU.jpg';
import TELHIO_CU from './Telhio_CU.jpg';
import TELCO_CCU from './Telco_CCU.png';
import Teachers_FCU from './Teachers_FCU.png';
import Swemp_LOGO from './Swemp.png';
import SUNCOAST_CU from './Suncoast_CU.png';
import State_Employees_Credit_Union_Logo from './StateEmployeesCreditUnion.jpg';
import StMaryBank_Logo from './StMaryBank.png';
import Space_Coast_CREDIT_UNION_LOGO from './Space_Coast_CU.png';
import Southwest_Financial_FCU_LOGO from './Southwest_Financial_FCU.png';
import Southeast_Michigan_State_Employees_Logo from './Southeast_Michigan_State_Employees.png';
import SOUTH_CAROLINA_FCU_LOGO from './South_Carolina_FCU.jpg';
import SINGING_RIVER_FCU_LOGO from './Singing_River_FCU.jpg';
import Sing_Sing_Employees_LOGO from './Sing_Sing_Employees.jpg';
import SIKORSKY_FINANCIAL_CU_LOGO from './Sikorsky_FCU.jpg';
import SIDNEY_FCU_LOGO from './Sidney_FCU.png';
import SECURITY_SERVICE_FCU_LOGO from './Security_Service_FCU.png';

import SEACOAST_BANK_LOGO from './SeacoastBank.png';
import SCHOOLSFIRST_FCU_LOGO from './SchoolsFirst_Logo.jpg';
import SC_STATE_FCU_LOGO from './SC_State_FCU.png';
import SANDIA_LABORATORY_FCU_LOGO from './Sandia_Lab_FCU.jpg';
import SAN_DIEGO_COUNTY_CU_LOGO from './San_Diego_County_CU.jpg';
import SAFE_FCU_LOGO from './SAFE_FCU.jpg';
import ROYAL_CREDIT_UNION_LOGO from './Royal_Credit_Union.jpg';
import ROLLING_F_CREDIT_UNION_LOGO from './Rolling_F_Credit_Union.jpg';
import ROCKLAND_FCU_LOGO from './Rockland_FCU.png';
import ROBINS_FINANCIAL_CU_LOGO from './Robins_Financial_Credit_Union.png';
import RIVERMARK_COMMUNITY_CU_LOGO from './Rivermark_Community_Credit_Union.png';
import REDSTONE_FCU_LOGO from './Redstone_FCU.png';
import RANDOLPH_BROOKS_FCU_LOGO from './Randolph_Brooks_FCU.jpg';
import QUORUM_FCU_LOGO from './Quorum_FCU.png';
import POLICE_AND_FIRE_FCU_LOGO from './Police_and_Fire_FCU.png';
import PEAKE_FCU_LOGO from './Peake_FCU.jpg';
import PATHWAYS_FINANCIAL_CU_LOGO from './Pathways_Financial_CU.jpg';
import PATELCO_CREDIT_UNION_LOGO from './Patelco_Credit_Union.jpg';
import P1FCU_LOGO from './P1FCU.jpg';
import ORNL_FCU_LOGO from './ORNL_FCU.png';
import OnPoint_CCU_LOGO from './OnPoint_CCU.jpg';
import OneAZ_CU_LOGO from './OneAZ_CU.png';
import ONE_NEVADA_CREDIT_UNION_LOGO from './One_Nevada_CU.jpg';
import OLD_HICKORY_CU_LOGO from './Old_Hickory_CU.jpg';
import NUSENDA_CREDIT_UNION_LOGO from './Nusenda_CU.png';
import Northwest_Arkansas_LOGO from './Northwest_Arkansas.png';
import NOBLE_CREDIT_UNION_LOGO from './Noble_CU.png';
import NEW_DIMENSIONS_FCU_LOGO from './New_Dimensions_FCU.jpg';
import NEIGHBORS_FCU_LOGO from './Neighbors_FCU.jpg';
import NAVIGANT_CU_LOGO from './Navigant_CU.png';
import NH_COMMUNITY_FCU_LOGO from './NH_Community_FCU.png';
import MUNICIPAL_CU_LOGO from './Municipal_CU.png';
import MOUNTAIN_AMERICA_CU_LOGO from './Mountain_America_CU.jpg';
import MOREHEAD_COMMUNITY_FCU_LOGO from './Morehead_Community_FCU.png';
import MidFlorida_Credit_Union_LOGO from './MidFlorida_CU.png';
import MID_HUDSON_VALLEY_FCU_LOGO from './Mid_Hudson_Valley_FCU.png';
import MID_OREGON_CREDIT_UNION_LOGO from './Mid_Oregon_CU.jpg';
import MICHIGAN_SCHOOLS_GOV_CREDIT_UNION_LOGO from './Michigan_Schools_GOV_Credit_Union.png';
import METRO_CU_LOGO from './Metrocu-Logo.png';
import Meritrust_CU_LOGO from './Meritrust_CU.jpg';
import MEMBERS_FIRST_FCU_LOGO from './Members_1st_FCU.png';
import MAZUMA_CREDIT_UNION_LOGO from './Mazuma_CU.png';
import MARINE_FCU_LOGO from './Marine_FCU.png';
import MAIN_STREET_CU_LOGO from './Mainstreet_CU.jpg';
import MAINE_SAVINGS_FCU_LOGO from './Maine_Savings_FCU.png';
import LOGIX_FCU_LOGO from './Logix_FCU.png';
import LOCAL_GOV_FCU_LOGO from './Local_Government_FCU.png';
import LOCAL_697_FCU_LOGO from './Local_697_FCU.png';
import LIGHTHOUSE_CREDIT_UNION_LOGO from './Lighthouse_CU.png';
import LIBERTY_FCU_LOGO from './Liberty_FCU.png';
import LAUNCH_CU_LOGO from './Launch_CU.png';
import LANGLEY_FCU_LOGO from './Langley_FCU.jpg';
import LAKE_MI_CU_LOGO from './Lake_Michigan_CU.jpg';
import L_AND_N_FCU_LOGO from './L&N_FCU.png';
import KNOXVILLE_TVA_EMPLOYEES_CU_LOGO from './Knoxville_TVA_Employees_CU.png';
import KIRTLAND_FCU_LOGO from './Kirtland_CU.jpg';
import JOVIA_FINANCIAL_CREDIT_UNION_LOGO from './Jovia_FCU.png';
import JEFFERSON_FINANCIAL_FCU_LOGO from './JF_FCU.png';
import IU_CREDIT_UNION_LOGO from './IUCreditUnion.png';
import IHMVCU_LOGO from './IHMVCUlogo_long.png';
import IDEAL_CREDIT_UNION_LOGO from './Ideal_Credit_Union.png';
import IDAHO_CENTRAL_CU_LOGO from './Idaho_Central_Credit_Union.png';
import HUGHES_FCU_LOGO from './Hughes_FCU.png';
import HUDSON_VALLEY_FCU_LOGO from './Hudson_Valley_CU.png';
import HOPE_CREDIT_UNION_LOGO from './Hope_Credit_Union.jpg';
import HOOSIER_HILLS_CREDIT_UNION_LOGO from './Hoosier_Hills_Credit_Union.png';
import HFS_FCU_LOGO from './HFS_Federal_Credit_Union.png';
import HAWAII_USA_FEDERAL_CREDIT_UNION_LOGO from './Hawaii_USA_Federal_Credit_Union.png';
import HAWAII_STATE_FCU_LOGO from './Hawaii_State_Federal_Credit_Union.png';
import HAWAII_CENTRAL_FCU_LOGO from './Hawaii_Central_Federal_Credit_Union.jpg';
import GSL_Savings_Bank_LOGO from './GSL_Savings_Bank.jpg';
import GREENSTATE_CREDIT_UNION_LOGO from './GreenState_Credit_Union.jpg';
import GREATER_EL_PASO_CU_LOGO from './Greater_EL_Paso_Credit_Union.png';
import GRANITE_CREDIT_UNION_LOGO from './granite-cu.jpg';
import GOLDENWEST_CU_LOGO from './Goldenwest_Credit_Union.png';
import GEORGIA_OWN_CU_LOGO from './Georgia_Own_Credit_Union.png';
import GENISYS_LOGO from './Genisys_CU.jpg';
import Generations_United_FCU_LOGO from './Generations_United_Federal_Credit_Union_NY.png';
import GenerationsFederalCreditUnion_TX from './GenerationsFederalCreditUnionTX.jpg';
import FRANKLIN_MINT_CU_LOGO from './Franklin_Mint_Credit_Union.png';
import FourLeaf_Federal_Credit_Union_LOGO from './FourLeaf_Federal_Credit_Union.png';
import Founders_Federal_Credit_Union_LOGO from './Founders_Federal_Credit_Union.png';
import FORUM_CREDIT_UNION_LOGO from './Forum_Credit_Union.png';
import FLORIDA_WEST_COAST_CU_LOGO from './Florida_West_Coast_Credit_Union.png';
import FLORIDA_CREDIT_UNION_LOGO from './Florida_Credit_Union.jpg';
import FIRSTLIGHT_FCU_LOGO from './FirstLight_Federal_Credit_Union.png';
import FIRST_COMMUNITY_CU_LOGO from './First_Community_Credit_Union.png';
import FIRST_CITIZENS_FCU_LOGO from './FIRST_CITIZENS_CU.jpg';
import FAMILY_TRUST_FCU_LOGO from './Family_Trust_Federal_Credit_Union.png';
import FAIRWINDS_CU_LOGO from './FAIRWINDS_Credit_Union.png';
import FAIRMONT_FCU_LOGO from './Fairmont_FCU.png';
import EVERWISE_CREDIT_UNION_LOGO from './Everwise_Credit_Union.png';
import EVERGREEN_CU_LOGO from './Evergreen_Credit_Union.png';
import ENT_CREDIT_UNION_LOGO from './Ent_Credit_Union.png';
import EMPOWER_FCU_LOGO from './Empower_Federal_Credit_Union.png';
import ELGA_CREDIT_UNION_LOGO from './ELGA_Credit_Union.jpg';
import EECU_CREDIT_UNION_LOGO from './EECU_Credit_Union.png';
import EDUCATORS_CU_LOGO from './Educators_CU_LOGO.png';
import EASTMAN_CREDIT_UNION_LOGO from './Eastman_Credit_Union.jpg';
import Eastern_Panhandle_FCU_LOGO from './Eastern_Panhandle_Federal_Credit_Union.png';
import DUPONT_CCU_LOGO from './DuPont_Community_Credit_Union.png';
import DUPACO_CREDIT_UNION_LOGO from './Dupaco_Credit_Union.png';
import DIRECTIONS_CREDIT_UNION_LOGO from './Directions_Credit_Union.png';
import Digital_Federal_Credit_Union_LOGO from './Digital_Federal_Credit_Union.png';
import DFCU_FINANCIAL_LOGO from './DFCU_Financial.png';
import DEXSTA_FCU_LOGO from './DEXSTA_Federal_Credit_Union.png';
import DESERT_FINANCIAL_CU_LOGO from './Desert_Financial_Credit_Union.png';
import Delta_Community_Credit_Union_LOGO from './Delta_Community_Credit_Union.png';
import DEL_NORTE_CREDIT_UNION_LOGO from './Del_Norte_Logo.png';
import CREDIT_UNION_OF_THE_ROCKIES_LOGO from './Credit_Union_of_Rockies.png';
import CREDIT_UNION_OF_DENVER_LOGO from './Credit_Union_of_Denver.png';
import CREDIT_UNION_OF_COLORADO_LOGO from './Credit_Union_of_Colorado.png';
import CREDIT_UNION_ONE_LOGO from './Credit_Union_1.png';
import CREDIT_UNION_ONE_ALASKA_LOGO from './Credit Union 1 Alaska.png';
import CPORT_CU_LOGO from './cPort_Credit_Union.png';
import COVANTAGE_CU_LOGO from './CoVantage_Credit_Union.jpg';
import CORNING_CREDIT_UNION_LOGO from './Corning_Credit_Union.png';
import CORDA_CREDIT_UNION_LOGO from './Corda_Credit_Union.jpg';
import CONSUMERS_CREDIT_UNION_MI_LOGO from './Consumers_Credit_Union_MI.jpg';
import CONNEXUS_CU_LOGO from './Connexus.png';
import COMMUNITY_SPIRIT_CREDIT_UNION_LOGO from './Community_Spirit_Credit_Union.jpg';
import COMMUNITY_PROMISE_FCU_LOGO from './Community_Promise_Federal_Credit_Union.png';
import COMMUNITY_1st_CU_IA_LOGO from './Community_First_Credit_Union_IA.jpg';
import COMMUNITY_FINANCIAL_CU_LOGO from './Community_FINANCIAL_FCU.png';
import COMMUNITY_CREDIT_UNION_OF_FL_LOGO from './Community_Credit_Union_of_Florida.jpg';
import COMMUNITY_CHOICE_CREDIT_UNION_MI_LOGO from './CCCU_MI.jpg';
import COMMUNITY_AMERICA_CU_LOGO from './community-america.jpg';
import COMMUNITY_AND_TEACHERS_FCU_LOGO from './Community_&_Teachers_FCU.png';
import COMMONWEALTH_CU_LOGO from './Commonwealth_Credit_Union.jpg';
import COBALT_CREDIT_UNION_LOGO from './Cobalt_Credit_Union.jpg';
import COASTAL_ONE_CU_LOGO from './Coastal1_Credit_Union.png';
import CLARK_COUNTY_CREDIT_UNION_LOGO from './Clark_County_Credit_Union.png';
import CLARITY_CU_LOGO from './Clarity_Credit_Union.png';
import CITY_OF_BOSTON_CU_LOGO from './City_of_Boston_Credit_Union.jpg';
import CITY_AND_COUNTY_CREDIT_UNION_LOGO from './City_And_County_CU.png';
import CHARTWAY_CREDIT_UNION_LOGO from './Chartway.png';
import CHARTER_OAK_FCU_LOGO from './Charter_Oak_FCU.png';
import CHARLESTON_SOUTH_ATLANTIC_BANK_LOGO from './Charleston_South_Atlantic_Bank.png';
import CENTRA_CREDIT_UNION_LOGO from './Centra_Credit_Union.png';
import CEDAR_POINT_FCU_LOGO from './Cedar_Point_Federal_Credit_Union.png';
import Canadaigua_Federal_Credit_Union_LOGO from './Canadaigua_FCU.png';
import CALIFORNIA_CREDIT_UNION_LOGO from './California_Credit_Union.png';
import BLUE_FCU_LOGO from './Blue_FCU.png';
import BLAZE_CREDIT_UNION_LOGO from './blaze-credit-union.jpg';
import BEEHIVE_FCU_LOGO from './Beehive_Federal_Credit_Union.png';
import BARKSDALE_FCU_LOGO from './Barksdale_Federal_Credit_Union.png';
import AZURA_CREDIT_UNION_LOGO from './Azura_Credit_Union.jpg';
import AVADIAN_CU_LOGO from './Avadian_Credit_Union.png';
import ATLANTIC_FCU_ME_LOGO from './Atlantic_FCU_ME.png';
import ARROWHEAD_CENTRAL_CU_LOGO from './Arrowhead_CU.jpg';
import ARKANSAS_FCU_LOGO from './Arkansas_FCU.png';
import ARIZONA_FINANCIAL_CU_LOGO from './Arizona_FCU.png';
import APG_FCU_LOGO from './APG_FCU.jpg';
import AMERICAN_HERITAGE_FCU_LOGO from './American_Heritage_FCU.png';
import AMERICA_FIRST_FCU_LOGO from './America_First_FCU.png';

import ALTANA_FCU_LOGO from './Altana_FCU.jpg';
import ALPENA_ALCONA_AREA_CU_LOGO from './Alpena_Alcona_Area_CU.jpg';
import ALLTRU_CREDIT_UNION_LOGO from './Alltru_Logo.png';
import ALLSOUTH_FCU_LOGO from './AllSouth_FCU.png';
import All_IN_CREDIT_UNION_LOGO from './All_In_Credit_Union.png';
import ALABAMA_CREDIT_UNION_LOGO from './Alabama_CU.jpg';
import AFFINITY_PLUS_FCU_LOGO from './Affinity_Plus.png';
import ADVIA_CREDIT_UNION_LOGO from './Advia_CU.jpg';
import ADVANCED_FINANCIAL_FCU_LOGO from './Advanced_Financial_FCU.jpg';
import ADDITION_FINANCIAL_LOGO from './Addition_Financial.png';

import SEVEN_SEVENTEEN_CU_LOGO from './Seven_Seventeen_Credit_Union.jpg';
import FIRST_NOR_CAL_CU_LOGO from './First_Nor_Cal_Credit_Union.png';

import VyStar_CU_LOGO from './VyStar_CU.png';
import Veridian_Credit_Union_LOGO from './Veridian_logo.png';

import GLOBAL_CU_LOGO from './Global_Credit_Union.jpg';
import WESTMARK_CU_LOGO from './WestMark.png';

import COMMUNITY_CHOICE_CREDIT_UNION_IA_LOGO from './Community_Choice_IA.png';

import COUNTY_FCU_LOGO from './CFCU.png';
import UNITUS_COMMUNITY_CU_LOGO from './Unitus-Logo.png';

import Knoxville_Law_Enforcement_FCU_LOGO from './Knoxville_Law_Enforcement_FCU.jpg';

import UCCU_LOGO from './UCCU.png';

import ESL_Federal_Credit_Union_LOGO from './ESL_FCU.png';

import KEESLER_FCU_LOGO from './Keesler_FCU.png';

import CLEARWATER_FCU_LOGO from './Clearwater_CU.jpg';

import AMERICAN_AIRLINES_CREDIT_UNION_LOGO from './American_Airlines_Credit_Union.jpg';

import AMERICA_FIRST_CU_LOGO from './America_First_CU.jpg';

import ABD_FCU_LOGO from './ABD_FCU.png';

import SALT_CITY_FCU_LOGO from './Salt_City_FCU.png';

export const CITI_BANK = 'Citibank';
export const CONNECT_ONE_BANK = 'ConnectOne Bank';
export const NAVY_FEDERAL = 'Navy Federal';
export const NAVY = 'Navy Federal Credit Union';
export const ADVANTAGE_FINANCIAL_FCU = 'Advantage Federal Credit Union';
export const GPO_FCU = 'GPO Federal Credit Union';
export const GE_CREDIT_UNION = 'GE Credit Union';
export const SYRACUSE_FIRE_DEPARTMENT_EMPLOYEES = 'Syracuse Fire Department Employees Credit Union';
export const SOLVAY_BANK = 'Solvay Bank';
export const FIRST_HERITAGE = 'First Heritage Federal Credit Union';
export const WATERTOWN_SAVINGS_BANK = 'Watertown Savings Bank';
export const CANANDAIGUA = 'Canandaigua Federal Credit Union';
export const GOUVERNEUR_SAVINGS_LOAN_ASSOCIATION = 'Gouverneur Savings & Loan Association';
export const SUMMIT_FCU = 'Summit Federal Credit Union';
export const PITTSFORD_FCU = 'Pittsford Federal Credit Union';
export const RELIANT_FCU = 'Reliant Community Federal Credit Union';
export const ONTARIO_SHORES_FCU = 'Ontario Shores Federal Credit Union';
export const GREAT_ERIE_FCU = 'Great Erie Federal Credit Union';
export const MERIDA_COMMUNITY_CREDIT_UNION = 'Meridia Community Credit Union';
export const AFFINITY_FCU = 'Affinity Federal Credit Union';
export const PICATINNY_FCU = 'Picatinny Federal Credit Union';
export const POLISH_AND_SLAVIC = 'Polish & Slavic Federal Credit Union';

export const BERKSHIRE_BANK = 'Berkshire Bank';
export const KINECTA_FCU = 'Kinecta Federal Credit Union';
export const TOGETHER_CREDIT_UNION = 'Together Credit Union';
export const BROADVIEW_FCU = 'Broadview Federal Credit Union';
export const NEXT_STEP_FCU = 'NextStep Federal Credit Union';
export const EIGHT_OH_TWO_CREDIT_UNION = '802 Credit Union';
export const GREEN_MOUNTAIN_CREDIT_UNION = 'Green Mountain Credit Union';
export const M_AND_T_BANK = 'M&T Bank';
export const EAST_RISE_CREDIT_UNION = 'EastRise Credit Union';
export const NORTH_COUNTRY_FCU = 'NorthCountry Federal Credit Union';
export const ONE_CREDIT_UNION = 'One Credit Union';
export const OPPORTUNITIES_CREDIT_UNION = 'Opportunities Credit Union';
export const VERMONT_FCU = 'Vermont Federal Credit Union';
export const ACCESS_FCU = 'Access Federal Credit Union';
export const SALT_CITY_FCU = 'Salt City Federal Credit Union';
export const OSWEGO_TEACHERS_EMPLOYEES_FCU = 'Oswego Teachers Employees Federal Credit Union';
export const AMERICU_CREDIT_UNION = 'AmeriCU Credit Union';
export const NORTHERN_CREDIT_UNION = 'Northern Credit Union';
export const COBBLESTONE_COUNTRY_FCU = 'Cobblestone Country Federal Credit Union';
export const ALLIANT_CREDIT_UNION = 'Alliant Credit Union';
export const BOK_FINANCIAL = 'BOK Financial';
export const HUNTINGTON_BANK = 'Huntington Bank';
export const PEN_FED_CREDIT_UNION = 'PenFed Credit Union';
export const US_BANK = 'US Bank';
export const NBKC = 'NBKC';

// New Logos Added
export const XCEL_Federal_Credit_Union = 'XCEL Federal Credit Union';
export const WINGS_FINANCIAL_CREDIT_UNION = 'Wings Financial Credit Union';

export const WEOKIE_FCU = 'WEOKIE Federal Credit Union';
export const VYSTAR_CU = 'VyStar Credit Union';
export const Veridian_Credit_Union = 'Veridian Credit Union';
export const VANTAGE_WEST_CU = 'Vantage West Credit Union';

export const Van_Lyons_Employees_FCU = 'Van Lyons Employees Federal Credit Union';

export const VALLEY_STRONG_CU = 'Valley Strong Credit Union';
export const VALLEY_FCU = 'Valley Federal Credit Union';

export const VALLEY_COMMUNITIES_CU = 'Valley Communities Credit Union';
export const UTAH_FIRST_FCU = 'Utah First Federal Credit Union';
export const Upstate_Telco_FCU = 'Upstate Telco Federal Credit Union';
export const UNIVERSITY_OF_KENTUCKY_FCU = 'University of Kentucky Federal Credit Union';

export const Union_Fidelity_FCU = 'Union Fidelity Federal Credit Union';
export const TYNDALL_FCU = 'Tyndall Federal Credit Union';

export const TTCU_FCU = 'TTCu Federal Credit Union';
export const TRUMARK_FINANCIAL_CREDIT_UNION = 'TruMark Financial Credit Union';
export const TOWN_AND_COUNTRY_FCU = 'Town & Country Federal Credit Union';
export const GOLDEN_ONE_CU = 'Golden 1 Credit Union';

export const Texhillco_School_Employees_FCU = 'Texhillco School Employees Federal Credit Union';
export const TN_VALLEY_FCU = 'Tennessee Valley Federal Credit Union';

export const TELHIO_CREDIT_UNION = 'Telhio Credit Union';
export const TELCO_COMMUNITY_CU = 'Telco Community Credit Union';
export const Teachers_Federal_Credit_Union = 'Teachers Federal Credit Union';
export const Swemp = 'Swemp';
export const Suncoast_Credit_Union = 'Suncoast Credit Union';
export const State_Employees_Credit_Union = "State Employees' Credit Union";
export const ST_MARY_BANK = "St. Mary's Bank";
export const Space_Coast_Credit_Union = 'Space Coast Credit Union';
export const Southwest_Financial_FCU = 'Southwest Financial Federal Credit Union';
export const Southeast_Michigan_State_Employees = 'Southeast Michigan State Employees';
export const SOUTH_CAROLINA_FCU = 'South Carolina Federal Credit Union';
export const SINGING_RIVER_FCU = 'Singing River Federal Credit Union';
export const Sing_Sing_Employees = 'Sing Sing Employees';
export const SIKORSKY_FINANCIAL_CU = 'Sikorsky Financial Credit Union';
export const SIDNEY_FCU = 'Sidney Federal Credit Union';
export const SECURITY_SERVICE_FCU = 'Security Service Federal Credit Union';

export const Seacoast_Bank = 'Seacoast Bank';
export const SCHOOLSFIRST_FCU = 'SchoolsFirst Federal Credit Union';
export const SC_STATE_FCU = 'SC State Federal Credit Union';
export const SANDIA_LABORATORY_FCU = 'Sandia Laboratory Federal Credit Union';
export const SAN_DIEGO_COUNTY_CU = 'San Diego County Credit Union';
export const SAFE_FCU = 'SAFE Federal Credit Union';
export const ROYAL_CREDIT_UNION = 'Royal Credit Union';
export const ROLLING_F_CU = 'Rolling F Credit Union';
export const ROCKLAND_FCU = 'Rockland Federal Credit Union';
export const ROBINS_FINANCIAL_CU = 'Robins Financial Credit Union';
export const RIVERMARK_COMMUNITY_CU = 'Rivermark Community Credit Union';
export const REDSTONE_FCU = 'Redstone Federal Credit Union';
export const RANDOLPH_BROOKS_FCU = 'Randolph-Brooks Federal Credit Union (RBFCU)';
export const QUORUM_FCU = 'Quorum Federal Credit Union';
export const POLICE_AND_FIRE_FCU = 'Police and Fire Federal Credit Union';
export const PEAKE_FCU = 'Peake Federal Credit Union';
export const PATHWAYS_FINANCIAL_CU = 'Pathways Financial Credit Union';
export const PATELCO_CREDIT_UNION = 'Patelco Credit Union';
export const P1FCU = 'P1FCU';
export const ORNL_FCU = 'ORNL Federal Credit Union';
export const OnPoint_CCU = 'OnPoint Community Credit Union';
export const OneAZ_CU = 'OneAZ Credit Union';
export const ONE_NEVADA_CREDIT_UNION = 'One Nevada Credit Union';
export const OLD_HICKORY_CU = 'Old Hickory Credit Union';
export const NUSENDA_CREDIT_UNION = 'Nusenda Credit Union';
export const Northwest_Arkansas = 'Northwest Arkansas';
export const NOBLE_CREDIT_UNION = 'Noble Credit Union';
export const NEW_DIMENSIONS_FCU = 'New Dimensions Federal Credit Union';
export const NEIGHBORS_FCU = 'Neighbors Federal Credit Union';
export const NAVIGANT_CU = 'Navigant Credit Union';
export const NH_COMMUNITY_FCU = 'N.H. Community Federal Credit Union';
export const Municipal_Credit_Union = 'Municipal Credit Union';
export const MOUNTAIN_AMERICA_CU = 'Mountain America Credit Union';
export const MOREHEAD_COMMUNITY_FCU = 'Morehead Community Federal Credit Union';
export const MidFlorida_Credit_Union = 'MidFlorida Credit Union';
export const MID_HUDSON_VALLEY_FCU = 'Mid-Hudson Valley Federal Credit Union';
export const MID_OREGON_CREDIT_UNION = 'Mid Oregon Credit Union';
export const MI_SCHOOLS_GOV_CREDIT_UNION = 'Michigan Schools and Government Credit Union';
export const METRO_CREDIT_UNION = 'Metro Credit Union';
export const MERITRUST_CREDIT_UNION = 'Meritrust Credit Union';
export const MEMBERS_FIRST_FCU = 'Members 1st Federal Credit Union';
export const MAZUMA_CREDIT_UNION = 'Mazuma Credit Union';
export const MARINE_FCU = 'Marine Federal Credit Union';
export const MAINSTREET_CREDIT_UNION = 'Mainstreet Credit Union';
export const MAINE_SAVINGS_FCU = 'Maine Savings Federal Credit Union';
export const LOGIX_FCU = 'Logix Federal Credit Union';
export const LOCAL_GOV_FCU = 'Local Government Federal Credit Union';
export const Local_697_FCU = 'Local 697 Federal Credit Union';
export const LIGHTHOUSE_CREDIT_UNION = 'Lighthouse Credit Union';
export const LIBERTY_FIRST_CREDIT_UNION = 'Liberty First Credit Union';
export const LAUNCH_CU = 'Launch Credit Union';
export const LANGLEY_FCU = 'Langley Federal Credit Union';
export const LAKE_MI_CU = 'Lake Michigan Credit Union';
export const L_AND_N_FCU = 'L&N Federal Credit Union';
export const Knoxville_Law_Enforcement_FCU = 'Knoxville Law Enforcement Federal Credit Union';
export const KIRTLAND_FCU = 'Kirtland Federal Credit Union';
export const JOVIA_FINANCIAL_CREDIT_UNION = 'Jovia Financial Credit Union';
export const JEFFERSON_FINANCIAL_FCU = 'Jefferson Financial Federal Credit Union';
export const IU_CREDIT_UNION = 'IU Credit Union';
export const IH_MS = 'IH Mississippi Valley Credit Union';
export const IDEAL_CREDIT_UNION = 'Ideal Credit Union';
export const IDAHO_CENTRAL_CU = 'Idaho Central Credit Union';
export const HUGHES_FCU = 'Hughes Federal Credit Union';
export const HUDSON_VALLEY_FCU = 'Hudson Valley Federal Credit Union';
export const HOPE_CREDIT_UNION = 'Hope Credit Union';
export const HOOSIER_HILLS_CREDIT_UNION = 'Hoosier Hills Credit Union';
export const HFS_FCU = 'HFS Federal Credit Union';
export const HAWAIIUSA_FCU = 'HawaiiUSA Federal Credit Union';
export const HAWAII_STATE_FCU = 'Hawaii State Federal Credit Union';
export const HAWAII_CENTRAL_FCU = 'Hawaii Central Federal Credit Union';
export const GSL_Savings_Bank = 'GSL Savings Bank';
export const GREENSTATE_CREDIT_UNION = 'GreenState Credit Union';
export const GREATER_EL_PASO_CU = 'Greater EL Paso Credit Union';
export const GRANITE_CREDIT_UNION = 'Granite Credit Union';
export const GOLDENWEST_CU = 'Goldenwest Credit Union';
export const GEORGIA_OWN_CU = "Georgia's Own Credit Union";
export const GENISYS_CU = 'Genisys Credit Union';
export const Generations_United_FCU_NY = 'Generations United Federal Credit Union';
export const GENERATIONS_FCU_TX = 'Generations Federal Credit Union';
export const FRANKLIN_MINT_CU = 'Franklin Mint Credit Union';
export const FourLeaf_Federal_Credit_Union = 'FourLeaf Federal Credit Union';
export const FOUNDERS_FCU = 'Founders Federal Credit Union';
export const FORUM_CREDIT_UNION = 'FORUM Credit Union';
export const FLORIDA_WEST_COAST_CU = 'Florida West Coast Credit Union';
export const FLORIDA_CREDIT_UNION = 'Florida Credit Union';
export const FIRSTLIGHT_FCU = 'FirstLight Federal Credit Union';
export const FIRST_COMMUNITY_CU = 'First Community Credit Union';
export const FIRST_CITIZENS_FCU = "First Citizens' Federal Credit Union";
export const FAMILY_TRUST_FCU = 'Family Trust Federal Credit Union';
export const FAIRWINDS_CU = 'FAIRWINDS Credit Union';
export const FAIRMONT_FCU = 'Fairmont Federal Credit Union';
export const EVERWISE_CREDIT_UNION = 'Everwise Credit Union';
export const EVERGREEN_CU = 'Evergreen Credit Union';
export const ENT_CU = 'Ent Credit Union';
export const EMPOWER_FCU = 'Empower Federal Credit Union';
export const ELGA_CREDIT_UNION = 'ELGA Credit Union';
export const EECU_CREDIT_UNION = 'EECU Credit Union';
export const EDUCATORS_CU = 'Educators Credit Union';
export const EASTMAN_CREDIT_UNION = 'Eastman Credit Union';
export const Eastern_Panhandle_FCU = 'Eastern Panhandle Federal Credit Union';
export const DUPONT_CCU = 'DuPont Community Credit Union';
export const DUPACO_CREDIT_UNION = 'Dupaco Credit Union';
export const DIRECTIONS_CREDIT_UNION = 'Directions Credit Union';
export const Digital_Federal_Credit_Union = 'Digital Federal Credit Union';
export const DFCU_FINANCIAL = 'DFCU Financial';
export const DEXSTA_FCU = 'DEXSTA Federal Credit Union';
export const DESERT_FINANCIAL_CU = 'Desert Financial Credit Union';
export const Delta_Community_Credit_Union = 'Delta Community Credit Union';
export const DEL_NORTE_CREDIT_UNION = 'Del Norte Credit Union';
export const CREDIT_UNION_OF_THE_ROCKIES = 'Credit Union of the Rockies';
export const CREDIT_UNION_OF_DENVER = 'Credit Union of Denver';
export const CREDIT_UNION_OF_COLORADO = 'Credit Union of Colorado';
export const CREDIT_UNIONT_1 = 'Credit Union 1';
export const CREDIT_UNION_1_AK = 'Credit Union 1 (Alaska)';
export const cPORT_CU = 'cPort Credit Union';
export const COVANTAGE_CU = 'CoVantage Credit Union';
export const CORNING_CREDIT_UNION = 'Corning Credit Union';
export const CORDA_CREDIT_UNION = 'Corda Credit Union';
export const CONSUMERS_CREDIT_UNION_MI = 'Consumers Credit Union (MI)';
export const CONNEXUS_CU = 'Connexus Credit Union';
export const COMMUNITY_SPIRIT_CREDIT_UNION = 'Community Spirit Credit Union';
export const COMMUNITY_PROMISE_FCU = 'Community Promise Federal Credit Union';
export const COMMUNITY_1st_CU = 'Community First Credit Union (IA)';
export const COMMUNITY_FINANCIAL_CU = 'Community Financial Credit Union';
export const COMMUNITY_CREDIT_UNION_OF_FL = 'Community Credit Union of Florida';
export const COMMUNITY_CHOICE_CREDIT_UNION_MI = 'Community Choice Credit Union';
export const COMMUNITY_AMERICA_CU = 'Community America Credit Union';
export const COMMUNITY_AND_TEACHERS_FCU = 'Community & Teachers Federal Credit Union';
export const COMMONWEALTH_CU = 'Commonwealth Credit Union';
export const COBALT_CREDIT_UNION = 'Cobalt Credit Union';
export const COASTAL_ONE_CU = 'Coastal1 Credit Union';
export const CLEARWATER_FCU = 'Clearwater Federal Credit Union';
export const CLARK_COUNTY_CREDIT_UNION = 'Clark County Credit Union';
export const CLARITY_CU = 'Clarity Credit Union';
export const CITY_OF_BOSTON_CU = 'City of Boston Credit Union';
export const CITY_AND_COUNTY_CREDIT_UNION = 'City & County Credit Union';
export const CHARTWAY_CREDIT_UNION = 'Chartway Credit Union';
export const CHARTER_OAK_FCU = 'Charter Oak Federal Credit Union';
export const South_Atlantic_Bank = 'Charleston (South Atlantic Bank)';
export const CENTRA_CREDIT_UNION = 'Centra Credit Union';
export const CEDAR_POINT_FCU = 'Cedar Point Federal Credit Union';
export const Canadaigua_Federal_Credit_Union = 'Canadaigua Federal Credit Union';
export const CALIFORNIA_CREDIT_UNION = 'California Credit Union';
export const BLUE_FCU = 'Blue Federal Credit Union';
export const BLAZE_CREDIT_UNION = 'Blaze Credit Union';
export const BEEHIVE_FCU = 'Beehive Federal Credit Union';
export const BARKSDALE_FCU = 'Barksdale Federal Credit Union';
export const AZURA_CREDIT_UNION = 'Azura Credit Union';
export const AVADIAN_CU = 'Avadian Credit Union';
export const ATLANTIC_FCU_ME = 'Atlantic Federal Credit Union (ME)';
export const ARROWHEAD_CENTRAL_CU = 'Arrowhead Central Credit Union';
export const AMERICAN_AIRLINES_CREDIT_UNION = 'American Airlines Federal Credit Union';
export const ARKANSAS_FCU = 'Arkansas Federal Credit Union';
export const ARIZONA_FINANCIAL_CU = 'Arizona Financial Credit Union';
export const APG_FCU = 'APG Federal Credit Union';
export const AMERICAN_HERITAGE_FCU = 'American Heritage Federal Credit Union';
export const AMERICA_FIRST_FCU = "America's First Federal Credit Union";
export const AMERICA_CREDIT_UNION = "America's Credit Union";
export const AMERICA_FIRST_CU = 'America First Credit Union';
export const ALTANA_FCU = 'Altana Federal Credit Union';
export const ALPENA_ALCONA_AREA_CU = 'Alpena Alcona Area Credit Union';
export const ALLTRU_CREDIT_UNION = 'Alltru Credit Union';
export const ALLSOUTH_FCU = 'AllSouth Federal Credit Union';

export const All_IN_CREDIT_UNION = 'All In Credit Union';
export const ALABAMA_CREDIT_UNION = 'Alabama Credit Union';
export const AFFINITY_PLUS_FCU = 'Affinity Plus Federal Credit Union';
export const ADVIA_CREDIT_UNION = 'Advia Credit Union';

export const ADVANCED_FINANCIAL_FCU = 'Advanced Financial Federal Credit Union';
export const ADDITION_FINANCIAL = 'Addition Financial';
export const ABD_FCU = 'ABD Federal Credit Union';

export const SEVEN_SEVENTEEN_CU = '7 17 Credit Union';
export const FIRST_NOR_CAL_CU = '1st Nor Cal Credit Union';

export const GLOBAL_CU = 'Global Credit Union';
export const WESTMARK_CU = 'Westmark Credit Union';
export const COMMUNITY_CHOICE_CREDIT_UNION_IA = 'Community Choice Credit Union (IA)';

export const COUNTY_FCU = 'The County Federal Credit Union';
export const UNITUS_COMMUNITY_CU = 'Unitus Community Credit Union';

export const KNOXVILLE_TVA_EMPLOYEES_CU = 'Knoxville TVA Employees Credit Union';

export const UTAH_COMMUNITY_CREDIT_UNION = 'Utah Community Credit Union';

export const ESL_Federal_Credit_Union = 'ESL Federal Credit Union';

export const KEESLER_FCU = 'Keesler Federal Credit Union';

export const LENDERS_LOGO_OBJ = {
  [CITI_BANK]: Citibank,
  [CONNECT_ONE_BANK]: ConnectOneBank,
  [NAVY_FEDERAL]: NavyFederal,
  [NAVY]: NavyFederal,
  [ADVANTAGE_FINANCIAL_FCU]: AdvantageFCU,
  [GPO_FCU]: GPOFCU,
  [GE_CREDIT_UNION]: GeCreditUnion,
  [SYRACUSE_FIRE_DEPARTMENT_EMPLOYEES]: SyracuseFireDepartment,
  [SOLVAY_BANK]: SolvayBank,
  [FIRST_HERITAGE]: FirstHeritage,
  [WATERTOWN_SAVINGS_BANK]: WatertownSavingsBank,
  [CANANDAIGUA]: CanandalguaFCU,
  [GOUVERNEUR_SAVINGS_LOAN_ASSOCIATION]: GSL,
  [SUMMIT_FCU]: SummitFCU,
  [PITTSFORD_FCU]: PittsfordFCU,
  [RELIANT_FCU]: ReliantCreditUnion,
  [ONTARIO_SHORES_FCU]: OntarioShoresFCU,
  [GREAT_ERIE_FCU]: GreatErieFCU,
  [MERIDA_COMMUNITY_CREDIT_UNION]: MeridaCCU,
  [AFFINITY_FCU]: Affinity,
  [PICATINNY_FCU]: PicatinnyFCU,
  [POLISH_AND_SLAVIC]: PolishAndSlavic,
  [BERKSHIRE_BANK]: BerkshireBank,
  [KINECTA_FCU]: Kinecta,
  [TOGETHER_CREDIT_UNION]: TogetherCreditUnion,
  [BROADVIEW_FCU]: BroadviewFCU,
  [NEXT_STEP_FCU]: NextStepFCU,
  [EIGHT_OH_TWO_CREDIT_UNION]: EightOhTwoCreditUnion,
  [GREEN_MOUNTAIN_CREDIT_UNION]: GreenMountainCU,
  [M_AND_T_BANK]: MAndTBank,
  [EAST_RISE_CREDIT_UNION]: EastRiseCU,
  [NORTH_COUNTRY_FCU]: NorthCountryCreditUnion,
  [ONE_CREDIT_UNION]: OneCreditUnion,
  [OPPORTUNITIES_CREDIT_UNION]: OpportunitiesCreditUnion,
  [VERMONT_FCU]: VermontFCU,
  [ACCESS_FCU]: AccessFCU,
  [SALT_CITY_FCU]: SALT_CITY_FCU_LOGO,
  [OSWEGO_TEACHERS_EMPLOYEES_FCU]: OswegoTeachersEmployeesFCU,
  [AMERICU_CREDIT_UNION]: Ameri,
  [NORTHERN_CREDIT_UNION]: NorthernCreditUnion,
  [COBBLESTONE_COUNTRY_FCU]: CobblestoneCountryFCU,
  [ALLIANT_CREDIT_UNION]: Alliant,
  [BOK_FINANCIAL]: BokFinancial,
  [HUNTINGTON_BANK]: Huntington,
  [PEN_FED_CREDIT_UNION]: PenFCU,
  [US_BANK]: UsBank,
  [NBKC]: NBKCBank,
  // New Ones Added
  [XCEL_Federal_Credit_Union]: XCEL_FCU,
  [WINGS_FINANCIAL_CREDIT_UNION]: WINGS_FCU,
  [WEOKIE_FCU]: WEOKIE_FEDERAL_CREDIT_UNION,
  [VANTAGE_WEST_CU]: VANTAGE_WEST_CREDIT_UNION,
  [Van_Lyons_Employees_FCU]: VAN_LYONS_EMPLOYEES_FCU,
  [VALLEY_STRONG_CU]: VALLEY_STRONG_CREDIT_UNION,
  [VALLEY_FCU]: VALLEY_FEDERAL_CREDIT_UNION,
  [VALLEY_COMMUNITIES_CU]: VALLEY_CCU,
  [UTAH_FIRST_FCU]: UTAH_FIRST_FEDERAL_CREDIT,
  [Upstate_Telco_FCU]: UPSTATE_TELCO_FEDERAL_CREDIT,
  [UNIVERSITY_OF_KENTUCKY_FCU]: UK_FCU,
  [Union_Fidelity_FCU]: Union_Fidelity_Federal_Credit,
  [TYNDALL_FCU]: TYNDALL_CREDIT_UNION,
  [TTCU_FCU]: TTCU_FEDERAL_CREDIT_UNION,
  [TRUMARK_FINANCIAL_CREDIT_UNION]: TruMark_Federal_Credit_Union,
  [TOWN_AND_COUNTRY_FCU]: Town_And_Country_Federal_Credit_Union,
  [GOLDEN_ONE_CU]: GOLDEN_ONE_Credit_Union,
  [Texhillco_School_Employees_FCU]: Texhillco_SCHOOL_EMPLOYEES_FEDERAL_CREDIT_UNION,
  [TN_VALLEY_FCU]: Tennessee_Valley_Federal_Credit_Union,
  [TELHIO_CREDIT_UNION]: TELHIO_CU,
  [TELCO_COMMUNITY_CU]: TELCO_CCU,
  [Teachers_Federal_Credit_Union]: Teachers_FCU,
  [Swemp]: Swemp_LOGO,
  [Suncoast_Credit_Union]: SUNCOAST_CU,
  [State_Employees_Credit_Union]: State_Employees_Credit_Union_Logo,
  [ST_MARY_BANK]: StMaryBank_Logo,
  [Space_Coast_Credit_Union]: Space_Coast_CREDIT_UNION_LOGO,
  [Southwest_Financial_FCU]: Southwest_Financial_FCU_LOGO,
  [Southeast_Michigan_State_Employees]: Southeast_Michigan_State_Employees_Logo,
  [SOUTH_CAROLINA_FCU]: SOUTH_CAROLINA_FCU_LOGO,
  [SINGING_RIVER_FCU]: SINGING_RIVER_FCU_LOGO,
  [Sing_Sing_Employees]: Sing_Sing_Employees_LOGO,
  [SIKORSKY_FINANCIAL_CU]: SIKORSKY_FINANCIAL_CU_LOGO,
  [SIDNEY_FCU]: SIDNEY_FCU_LOGO,
  [SECURITY_SERVICE_FCU]: SECURITY_SERVICE_FCU_LOGO,
  [Seacoast_Bank]: SEACOAST_BANK_LOGO,
  [SCHOOLSFIRST_FCU]: SCHOOLSFIRST_FCU_LOGO,
  [SC_STATE_FCU]: SC_STATE_FCU_LOGO,
  [SANDIA_LABORATORY_FCU]: SANDIA_LABORATORY_FCU_LOGO,
  [SAN_DIEGO_COUNTY_CU]: SAN_DIEGO_COUNTY_CU_LOGO,
  [SAFE_FCU]: SAFE_FCU_LOGO,
  [ROYAL_CREDIT_UNION]: ROYAL_CREDIT_UNION_LOGO,
  [ROLLING_F_CU]: ROLLING_F_CREDIT_UNION_LOGO,
  [ROCKLAND_FCU]: ROCKLAND_FCU_LOGO,
  [ROBINS_FINANCIAL_CU]: ROBINS_FINANCIAL_CU_LOGO,
  [RIVERMARK_COMMUNITY_CU]: RIVERMARK_COMMUNITY_CU_LOGO,
  [REDSTONE_FCU]: REDSTONE_FCU_LOGO,
  [RANDOLPH_BROOKS_FCU]: RANDOLPH_BROOKS_FCU_LOGO,
  [QUORUM_FCU]: QUORUM_FCU_LOGO,
  [POLICE_AND_FIRE_FCU]: POLICE_AND_FIRE_FCU_LOGO,
  [PEAKE_FCU]: PEAKE_FCU_LOGO,
  [PATHWAYS_FINANCIAL_CU]: PATHWAYS_FINANCIAL_CU_LOGO,
  [PATELCO_CREDIT_UNION]: PATELCO_CREDIT_UNION_LOGO,
  [P1FCU]: P1FCU_LOGO,
  [ORNL_FCU]: ORNL_FCU_LOGO,
  [OnPoint_CCU]: OnPoint_CCU_LOGO,
  [OneAZ_CU]: OneAZ_CU_LOGO,
  [ONE_NEVADA_CREDIT_UNION]: ONE_NEVADA_CREDIT_UNION_LOGO,
  [OLD_HICKORY_CU]: OLD_HICKORY_CU_LOGO,
  [NUSENDA_CREDIT_UNION]: NUSENDA_CREDIT_UNION_LOGO,
  [Northwest_Arkansas]: Northwest_Arkansas_LOGO,
  [NOBLE_CREDIT_UNION]: NOBLE_CREDIT_UNION_LOGO,
  [NEW_DIMENSIONS_FCU]: NEW_DIMENSIONS_FCU_LOGO,
  [NEIGHBORS_FCU]: NEIGHBORS_FCU_LOGO,
  [NAVIGANT_CU]: NAVIGANT_CU_LOGO,
  [NH_COMMUNITY_FCU]: NH_COMMUNITY_FCU_LOGO,
  [Municipal_Credit_Union]: MUNICIPAL_CU_LOGO,
  [MOUNTAIN_AMERICA_CU]: MOUNTAIN_AMERICA_CU_LOGO,
  [MOREHEAD_COMMUNITY_FCU]: MOREHEAD_COMMUNITY_FCU_LOGO,
  [MidFlorida_Credit_Union]: MidFlorida_Credit_Union_LOGO,
  [MID_HUDSON_VALLEY_FCU]: MID_HUDSON_VALLEY_FCU_LOGO,
  [MID_OREGON_CREDIT_UNION]: MID_OREGON_CREDIT_UNION_LOGO,
  [MI_SCHOOLS_GOV_CREDIT_UNION]: MICHIGAN_SCHOOLS_GOV_CREDIT_UNION_LOGO,
  [METRO_CREDIT_UNION]: METRO_CU_LOGO,
  [MERITRUST_CREDIT_UNION]: Meritrust_CU_LOGO,
  [MEMBERS_FIRST_FCU]: MEMBERS_FIRST_FCU_LOGO,
  [MAZUMA_CREDIT_UNION]: MAZUMA_CREDIT_UNION_LOGO,
  [MARINE_FCU]: MARINE_FCU_LOGO,
  [MAINSTREET_CREDIT_UNION]: MAIN_STREET_CU_LOGO,
  [MAINE_SAVINGS_FCU]: MAINE_SAVINGS_FCU_LOGO,
  [LOGIX_FCU]: LOGIX_FCU_LOGO,
  [LOCAL_GOV_FCU]: LOCAL_GOV_FCU_LOGO,
  [Local_697_FCU]: LOCAL_697_FCU_LOGO,
  [LIGHTHOUSE_CREDIT_UNION]: LIGHTHOUSE_CREDIT_UNION_LOGO,
  [LIBERTY_FIRST_CREDIT_UNION]: LIBERTY_FCU_LOGO,
  [LAUNCH_CU]: LAUNCH_CU_LOGO,
  [LANGLEY_FCU]: LANGLEY_FCU_LOGO,
  [LAKE_MI_CU]: LAKE_MI_CU_LOGO,
  [L_AND_N_FCU]: L_AND_N_FCU_LOGO,
  [Knoxville_Law_Enforcement_FCU]: Knoxville_Law_Enforcement_FCU_LOGO,
  [KIRTLAND_FCU]: KIRTLAND_FCU_LOGO,
  [JOVIA_FINANCIAL_CREDIT_UNION]: JOVIA_FINANCIAL_CREDIT_UNION_LOGO,
  [JEFFERSON_FINANCIAL_FCU]: JEFFERSON_FINANCIAL_FCU_LOGO,
  [IU_CREDIT_UNION]: IU_CREDIT_UNION_LOGO,
  [IH_MS]: IHMVCU_LOGO,
  [IDEAL_CREDIT_UNION]: IDEAL_CREDIT_UNION_LOGO,
  [IDAHO_CENTRAL_CU]: IDAHO_CENTRAL_CU_LOGO,
  [HUGHES_FCU]: HUGHES_FCU_LOGO,
  [HUDSON_VALLEY_FCU]: HUDSON_VALLEY_FCU_LOGO,
  [HOPE_CREDIT_UNION]: HOPE_CREDIT_UNION_LOGO,
  [HOOSIER_HILLS_CREDIT_UNION]: HOOSIER_HILLS_CREDIT_UNION_LOGO,
  [HFS_FCU]: HFS_FCU_LOGO,
  [HAWAIIUSA_FCU]: HAWAII_USA_FEDERAL_CREDIT_UNION_LOGO,
  [HAWAII_STATE_FCU]: HAWAII_STATE_FCU_LOGO,
  [HAWAII_CENTRAL_FCU]: HAWAII_CENTRAL_FCU_LOGO,
  [GSL_Savings_Bank]: GSL_Savings_Bank_LOGO,
  [GREENSTATE_CREDIT_UNION]: GREENSTATE_CREDIT_UNION_LOGO,
  [GREATER_EL_PASO_CU]: GREATER_EL_PASO_CU_LOGO,
  [GRANITE_CREDIT_UNION]: GRANITE_CREDIT_UNION_LOGO,
  [GOLDENWEST_CU]: GOLDENWEST_CU_LOGO,
  [GEORGIA_OWN_CU]: GEORGIA_OWN_CU_LOGO,
  [GENISYS_CU]: GENISYS_LOGO,
  [Generations_United_FCU_NY]: Generations_United_FCU_LOGO,
  [GENERATIONS_FCU_TX]: GenerationsFederalCreditUnion_TX,
  [FRANKLIN_MINT_CU]: FRANKLIN_MINT_CU_LOGO,
  [FourLeaf_Federal_Credit_Union]: FourLeaf_Federal_Credit_Union_LOGO,
  [FOUNDERS_FCU]: Founders_Federal_Credit_Union_LOGO,
  [FORUM_CREDIT_UNION]: FORUM_CREDIT_UNION_LOGO,
  [FLORIDA_WEST_COAST_CU]: FLORIDA_WEST_COAST_CU_LOGO,
  [FLORIDA_CREDIT_UNION]: FLORIDA_CREDIT_UNION_LOGO,
  [FIRSTLIGHT_FCU]: FIRSTLIGHT_FCU_LOGO,
  [FIRST_COMMUNITY_CU]: FIRST_COMMUNITY_CU_LOGO,
  [FIRST_CITIZENS_FCU]: FIRST_CITIZENS_FCU_LOGO,
  [FAMILY_TRUST_FCU]: FAMILY_TRUST_FCU_LOGO,
  [FAIRWINDS_CU]: FAIRWINDS_CU_LOGO,
  [FAIRMONT_FCU]: FAIRMONT_FCU_LOGO,
  [EVERWISE_CREDIT_UNION]: EVERWISE_CREDIT_UNION_LOGO,
  [EVERGREEN_CU]: EVERGREEN_CU_LOGO,
  [ENT_CU]: ENT_CREDIT_UNION_LOGO,
  [EMPOWER_FCU]: EMPOWER_FCU_LOGO,
  [ELGA_CREDIT_UNION]: ELGA_CREDIT_UNION_LOGO,
  [EECU_CREDIT_UNION]: EECU_CREDIT_UNION_LOGO,
  [EDUCATORS_CU]: EDUCATORS_CU_LOGO,
  [EASTMAN_CREDIT_UNION]: EASTMAN_CREDIT_UNION_LOGO,
  [Eastern_Panhandle_FCU]: Eastern_Panhandle_FCU_LOGO,
  [DUPONT_CCU]: DUPONT_CCU_LOGO,
  [DUPACO_CREDIT_UNION]: DUPACO_CREDIT_UNION_LOGO,
  [DIRECTIONS_CREDIT_UNION]: DIRECTIONS_CREDIT_UNION_LOGO,
  [Digital_Federal_Credit_Union]: Digital_Federal_Credit_Union_LOGO,
  [DFCU_FINANCIAL]: DFCU_FINANCIAL_LOGO,
  [DEXSTA_FCU]: DEXSTA_FCU_LOGO,
  [DESERT_FINANCIAL_CU]: DESERT_FINANCIAL_CU_LOGO,
  [Delta_Community_Credit_Union]: Delta_Community_Credit_Union_LOGO,
  [DEL_NORTE_CREDIT_UNION]: DEL_NORTE_CREDIT_UNION_LOGO,
  [CREDIT_UNION_OF_THE_ROCKIES]: CREDIT_UNION_OF_THE_ROCKIES_LOGO,
  [CREDIT_UNION_OF_DENVER]: CREDIT_UNION_OF_DENVER_LOGO,
  [CREDIT_UNION_OF_COLORADO]: CREDIT_UNION_OF_COLORADO_LOGO,
  [CREDIT_UNIONT_1]: CREDIT_UNION_ONE_LOGO,
  [CREDIT_UNION_1_AK]: CREDIT_UNION_ONE_ALASKA_LOGO,
  [cPORT_CU]: CPORT_CU_LOGO,
  [COVANTAGE_CU]: COVANTAGE_CU_LOGO,
  [CORNING_CREDIT_UNION]: CORNING_CREDIT_UNION_LOGO,
  [CORDA_CREDIT_UNION]: CORDA_CREDIT_UNION_LOGO,
  [CONSUMERS_CREDIT_UNION_MI]: CONSUMERS_CREDIT_UNION_MI_LOGO,
  [CONNEXUS_CU]: CONNEXUS_CU_LOGO,
  [COMMUNITY_SPIRIT_CREDIT_UNION]: COMMUNITY_SPIRIT_CREDIT_UNION_LOGO,
  [COMMUNITY_PROMISE_FCU]: COMMUNITY_PROMISE_FCU_LOGO,
  [COMMUNITY_1st_CU]: COMMUNITY_1st_CU_IA_LOGO,
  [COMMUNITY_FINANCIAL_CU]: COMMUNITY_FINANCIAL_CU_LOGO,
  [COMMUNITY_CREDIT_UNION_OF_FL]: COMMUNITY_CREDIT_UNION_OF_FL_LOGO,
  [COMMUNITY_CHOICE_CREDIT_UNION_MI]: COMMUNITY_CHOICE_CREDIT_UNION_MI_LOGO,
  [COMMUNITY_AMERICA_CU]: COMMUNITY_AMERICA_CU_LOGO,
  [COMMUNITY_AND_TEACHERS_FCU]: COMMUNITY_AND_TEACHERS_FCU_LOGO,
  [COMMONWEALTH_CU]: COMMONWEALTH_CU_LOGO,
  [COBALT_CREDIT_UNION]: COBALT_CREDIT_UNION_LOGO,
  [COASTAL_ONE_CU]: COASTAL_ONE_CU_LOGO,
  [CLEARWATER_FCU]: CLEARWATER_FCU_LOGO,
  [CLARK_COUNTY_CREDIT_UNION]: CLARK_COUNTY_CREDIT_UNION_LOGO,
  [CLARITY_CU]: CLARITY_CU_LOGO,
  [CITY_OF_BOSTON_CU]: CITY_OF_BOSTON_CU_LOGO,
  [CITY_AND_COUNTY_CREDIT_UNION]: CITY_AND_COUNTY_CREDIT_UNION_LOGO,
  [CHARTWAY_CREDIT_UNION]: CHARTWAY_CREDIT_UNION_LOGO,
  [CHARTER_OAK_FCU]: CHARTER_OAK_FCU_LOGO,
  [South_Atlantic_Bank]: CHARLESTON_SOUTH_ATLANTIC_BANK_LOGO,
  [CENTRA_CREDIT_UNION]: CENTRA_CREDIT_UNION_LOGO,
  [CEDAR_POINT_FCU]: CEDAR_POINT_FCU_LOGO,
  [Canadaigua_Federal_Credit_Union]: Canadaigua_Federal_Credit_Union_LOGO,
  [CALIFORNIA_CREDIT_UNION]: CALIFORNIA_CREDIT_UNION_LOGO,
  [BLUE_FCU]: BLUE_FCU_LOGO,
  [BLAZE_CREDIT_UNION]: BLAZE_CREDIT_UNION_LOGO,
  [BEEHIVE_FCU]: BEEHIVE_FCU_LOGO,
  [BARKSDALE_FCU]: BARKSDALE_FCU_LOGO,
  [AZURA_CREDIT_UNION]: AZURA_CREDIT_UNION_LOGO,
  [AVADIAN_CU]: AVADIAN_CU_LOGO,
  [ATLANTIC_FCU_ME]: ATLANTIC_FCU_ME_LOGO,
  [ARROWHEAD_CENTRAL_CU]: ARROWHEAD_CENTRAL_CU_LOGO,
  [AMERICAN_AIRLINES_CREDIT_UNION]: AMERICAN_AIRLINES_CREDIT_UNION_LOGO,
  [ARKANSAS_FCU]: ARKANSAS_FCU_LOGO,
  [ARIZONA_FINANCIAL_CU]: ARIZONA_FINANCIAL_CU_LOGO,
  [APG_FCU]: APG_FCU_LOGO,
  [AMERICAN_HERITAGE_FCU]: AMERICAN_HERITAGE_FCU_LOGO,
  [AMERICA_FIRST_FCU]: AMERICA_FIRST_FCU_LOGO,
  [AMERICA_CREDIT_UNION]: '',
  [AMERICA_FIRST_CU]: AMERICA_FIRST_CU_LOGO,
  [ALTANA_FCU]: ALTANA_FCU_LOGO,
  [ALPENA_ALCONA_AREA_CU]: ALPENA_ALCONA_AREA_CU_LOGO,
  [ALLTRU_CREDIT_UNION]: ALLTRU_CREDIT_UNION_LOGO,
  [ALLSOUTH_FCU]: ALLSOUTH_FCU_LOGO,
  [All_IN_CREDIT_UNION]: All_IN_CREDIT_UNION_LOGO,
  [ALABAMA_CREDIT_UNION]: ALABAMA_CREDIT_UNION_LOGO,
  [AFFINITY_PLUS_FCU]: AFFINITY_PLUS_FCU_LOGO,
  [ADVIA_CREDIT_UNION]: ADVIA_CREDIT_UNION_LOGO,
  [ADVANCED_FINANCIAL_FCU]: ADVANCED_FINANCIAL_FCU_LOGO,
  [ADDITION_FINANCIAL]: ADDITION_FINANCIAL_LOGO,
  [ABD_FCU]: ABD_FCU_LOGO,
  [SEVEN_SEVENTEEN_CU]: SEVEN_SEVENTEEN_CU_LOGO,
  [FIRST_NOR_CAL_CU]: FIRST_NOR_CAL_CU_LOGO,
  [VYSTAR_CU]: VyStar_CU_LOGO,
  [Veridian_Credit_Union]: Veridian_Credit_Union_LOGO,
  [GLOBAL_CU]: GLOBAL_CU_LOGO,
  [WESTMARK_CU]: WESTMARK_CU_LOGO,
  [COMMUNITY_CHOICE_CREDIT_UNION_IA]: COMMUNITY_CHOICE_CREDIT_UNION_IA_LOGO,
  [COUNTY_FCU]: COUNTY_FCU_LOGO,
  [UNITUS_COMMUNITY_CU]: UNITUS_COMMUNITY_CU_LOGO,
  [KNOXVILLE_TVA_EMPLOYEES_CU]: KNOXVILLE_TVA_EMPLOYEES_CU_LOGO,
  [UTAH_COMMUNITY_CREDIT_UNION]: UCCU_LOGO,
  [ESL_Federal_Credit_Union]: ESL_Federal_Credit_Union_LOGO,
  [KEESLER_FCU]: KEESLER_FCU_LOGO,
};

export const WAKOTA_FCU = 'Wakota Federal Credit Union';
export const Vicksburg_Railroad_CU = 'Vicksburg Railroad Credit Union';

export const STATE_EMPLOYEES_CU = 'State Employees Credit Union';
